import { useState, useEffect } from 'react';
import './FloatingModal.scss';
import { CloseOutlined, ExpandOutlined, LineOutlined } from '@ant-design/icons';
import { t } from '../../i18n/i18n';

const FloatingModal = ({ show, onClose, children, title = 'Modal', className = '' }) => {
  const [isMinimized, setIsMinimized] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (show) {
      setIsVisible(true);
      setIsClosing(false);
    } else {
      setIsClosing(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
        setIsClosing(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [show]);

  if (!isVisible) return null;

  const handleMinimize = () => {
    setIsMinimized(!isMinimized);
  };

  const handleClose = () => {
    setIsMinimized(false);
    onClose();
  };

  return (
    <div
      className={`floating-modal ${isMinimized ? 'minimized' : ''} ${
        isClosing ? 'closing' : 'opening'
      } ${className}`}
    >
      <div className="floating-modal-header">
        <h4 className="floating-modal-title">{title}</h4>
        <div className="floating-modal-controls">
          <button
            type="button"
            className="floating-modal-minimize"
            onClick={handleMinimize}
            title={isMinimized ? t('EXPAND') : t('MINIMIZE')}
          >
            {isMinimized ? <ExpandOutlined /> : <LineOutlined />}
          </button>
          <button
            type="button"
            className="floating-modal-close"
            onClick={handleClose}
            title={t('CLOSE')}
          >
            <CloseOutlined />
          </button>
        </div>
      </div>

      {!isMinimized && <div className="floating-modal-content">{children}</div>}
    </div>
  );
};

export default FloatingModal;
